export const ApplicationDeletionDialogMessage = {
    application: {
        modalTitle: 'Delete Application?',
        modalContent:
            'Are you sure you want to permanently delete this application?',
        primaryActionTitle: 'Delete',
        successfulAlertMessage:
            'Application information has been successfully deleted.',
    },
    template: {
        modalTitle: 'Delete Template?',
        modalContent:
            'Are you sure you want to permanently delete this template?',
        primaryActionTitle: 'Delete',
        successfulAlertMessage:
            'Template information has been successfully deleted.',
    },
} as const;
